import React from "react";

class ImageTextItem extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
        };
    }

    render() {
        const item = this.props.item;

        return (
            <div className={item.BackgroundColor && "imagetext__item-container"} style={{ background: item.BackgroundColor, color: item.FontColor }}>
                <div>
                {item.Video != null ? (
                    <div className={"imagetext__video"}>
                        <video className="video__player" playsInline webkit-playsinline="true" autoPlay muted loop>
                            <source src={item.VideoMobileUrl.Url} type={item.VideoMobileUrl.VideoFormat} media="(max-width:640px)" />
                            <source src={item.VideoUrl.Url} type={item.VideoUrl.VideoFormat} />
                        </video>
                    </div>)
                    : (item.Image != "" &&
                        <>
                        {item.LinkUrl && item.LinkImage ? 
                            <>
                                <a href={item.LinkUrl}>
                                    <figure className={`imagetext__image ${item.MobileImage != "" ? "imagetext__image--hide-in-mobile" : ""}`} dangerouslySetInnerHTML={{ __html: item.Image }} />
                                    {item.MobileImage != "" &&
                                    <figure className={"imagetext__image imagetext__image--hide-in-desktop"} dangerouslySetInnerHTML={{ __html: item.MobileImage }} />
                                    }
                                </a>
                            </>
                            : 
                            <>
                                <figure className={`imagetext__image ${item.MobileImage != "" ? "imagetext__image--hide-in-mobile" : ""}`} dangerouslySetInnerHTML={{ __html: item.Image }} />
                                {item.MobileImage != "" &&
                                <figure className={"imagetext__image imagetext__image--hide-in-desktop"} dangerouslySetInnerHTML={{ __html: item.MobileImage }} />
                                }
                            </> 
                        }
                        </>
                    )
                }
                {(item.Title || item.Text.Value || (item.LinkUrl && item.LinkText)) &&
                    <div className="imagetext__content">
                        {item.Title && item.MainTitle &&
                            <h1 className="imagetext__title">
                                {item.Title}
                            </h1>
                        }
                        {item.Title && !item.MainTitle &&
                            <h2 className="imagetext__title">
                                {item.Title}
                            </h2>
                        }
                        {item.Text.Value &&
                            <div className="imagetext__text" dangerouslySetInnerHTML={{ __html: item.Text.Value }}>
                            </div>
                        }
                    </div>
                }
                </div>
                {item.LinkUrl && item.LinkText &&
                    <div className="imagetext__button-wrapper">
                        <a className={"button " + item.ButtonDesign + " " + item.ButtonSize} href={item.LinkUrl}>{item.LinkText}</a>
                    </div>
                }
            </div>
        );
    }
}

export default ImageTextItem;